import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectEffectiveTaxRateCellForDetails,
} from './store/actions';

class EffectiveTaxRateDetailLink extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    selectEffectiveTaxRateCellForDetails: PropTypes.func.isRequired,
    tagName: PropTypes.string.isRequired,
    ibtAmount: PropTypes.number.isRequired,
    account: PropTypes.string,
    countryTaxType: PropTypes.string,
    index: PropTypes.number,
    cellToElevateSelector: PropTypes.string,
  };

  handleClick = event => {
    event.preventDefault();
    event.stopPropagation();

    const {
      selectEffectiveTaxRateCellForDetails,
      tagName,
      ibtAmount,
      account,
      countryTaxType,
      index,
      cellToElevateSelector,
    } = this.props;

    selectEffectiveTaxRateCellForDetails({
      tagName,
      ibtAmount,
      account,
      countryTaxType,
      index,
      cellToElevateSelector,
    });
  };

  render() {
    return (
      <a href="#details" data-tip="" data-for="effectiveTaxRateDetails" onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}

export default connect(null, {
  selectEffectiveTaxRateCellForDetails,
})(EffectiveTaxRateDetailLink);
